import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLString,
  GraphQLBoolean
} from 'graphql'

export const remediationPolicyType = new GraphQLObjectType({
  name: 'RemediationPolicy',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString)
    },
    id: {
      type: new GraphQLNonNull(GraphQLID)
    },
    enabled: {
      description: 'Is the policy enabled for the organization',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    action: {
      description: 'Is the remediation policy type',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})
